var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_56_18",
    "data-name": "Component 56 \\u2013 18",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11417",
    "data-name": "Group 11417",
    transform: "translate(-112.126 1304.631) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11415",
    "data-name": "Group 11415",
    transform: "translate(-0.435 1.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11966",
    "data-name": "Path 11966",
    d: "M-519.011,16246.642l.011,9.388",
    transform: "translate(1807.446 -16128.001)",
    fill: "none",
    stroke: "#810055",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11967",
    "data-name": "Path 11967",
    d: "M-522.065,16253.988l3.573,3.213,3.419-3.213",
    transform: "translate(1807 -16129.174)",
    fill: "none",
    stroke: "#810055",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11968",
    "data-name": "Path 11968",
    d: "M-525.234,16256H-527v5.768h13.261V16256h-1.737",
    transform: "translate(1808.369 -16126.986)",
    fill: "none",
    stroke: "#810055",
    strokeWidth: 1.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3682",
    "data-name": "Rectangle 3682",
    width: 32,
    height: 32,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/LogOut.d2def882ab5be976576503c04fdb8b0d.svg";
export { ForwardRef as ReactComponent };